var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83366 9.99992H6.50033C5.40673 9.9995 4.33381 10.298 3.39758 10.8632C2.46134 11.4284 1.69739 12.2387 1.18833 13.2066C1.17402 13.0269 1.1669 12.8468 1.16699 12.6666C1.16699 8.98459 4.15166 5.99992 7.83366 5.99992V2.33325L14.8337 7.99992L7.83366 13.6666V9.99992Z",
    stroke: "#282B59",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.8c9171f15f3f4be37fd0f67bcae0940f.svg";
export { ForwardRef as ReactComponent };